import { useState, useCallback } from 'react';

/**
 * Custom hook for handling report popup functionality
 * @returns {Object} Object containing report popup state and handler functions
 */
export const useReportPopup = () => {
  const [reportPopupOpen, setReportPopupOpen] = useState(false);
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  
  const openReportPopup = useCallback((questionId, question) => {
    setCurrentQuestionId(questionId);
    setCurrentQuestion(question);
    setReportPopupOpen(true);
  }, []);
  
  const closeReportPopup = useCallback(() => {
    setReportPopupOpen(false);
    setCurrentQuestionId(null);
    setCurrentQuestion(null);
  }, []);
  
  return { 
    reportPopupOpen, 
    currentQuestionId, 
    currentQuestion, 
    openReportPopup, 
    closeReportPopup 
  };
};
